import createAction from "../../lib/createAction";

export const ACTIVE_USERS_CHANGED = "ACTIVE_USERS_CHANGED";
export const activeUsersChanged = createAction(ACTIVE_USERS_CHANGED, "activeUsers");
